import { useEffect } from "react";
import { getConsent } from "./CookieConsent";
import { api } from "../lib/api";

/**
 * Pilotage Consent Mode v2 pour Google AdSense.
 *
 * Le script AdSense lui-même est chargé statiquement depuis `public/index.html`
 * (obligatoire pour la validation Google : le crawler doit voir la balise
 * dès le premier chargement, sans exécution de JS différée).
 *
 * Ce composant :
 *   1. Vérifie le kill switch admin (`/public/adsense-status`) et retire le
 *      script du DOM si l'admin a désactivé AdSense.
 *   2. Initialise Google Consent Mode v2 avec les défauts issus du CMP MBOAZICK.
 *   3. Met à jour dynamiquement le consentement lors des changements user.
 *
 * → Aucun cookie publicitaire n'est déposé tant que l'utilisateur n'a pas
 *   accepté la catégorie « Publicité ».
 */
export default function GoogleAdSense() {
    useEffect(() => {
        // 1. Init Consent Mode v2 défauts AVANT toute activation
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = window.gtag || gtag;

        const consent = getConsent();
        const adGranted = consent?.advertising ? "granted" : "denied";
        const anaGranted = consent?.analytics ? "granted" : "denied";
        window.gtag("consent", "default", {
            ad_storage: adGranted,
            ad_user_data: adGranted,
            ad_personalization: adGranted,
            analytics_storage: anaGranted,
            wait_for_update: 500,
        });

        // 2. Réagir aux changements de consentement
        const onConsentChange = (e) => {
            const c = e.detail || {};
            const ad = c.advertising ? "granted" : "denied";
            const ana = c.analytics ? "granted" : "denied";
            window.gtag("consent", "update", {
                ad_storage: ad,
                ad_user_data: ad,
                ad_personalization: ad,
                analytics_storage: ana,
            });
        };
        window.addEventListener("mboa-consent-change", onConsentChange);

        // 3. Kill switch admin — si désactivé, on retire le script du DOM
        let cancelled = false;
        api.get("/public/adsense-status").then(({ data }) => {
            if (cancelled) return;
            if (!data?.enabled) {
                const existing = document.querySelector('script[src*="pagead2.googlesyndication.com"]');
                if (existing) existing.remove();
            }
        }).catch(() => {});

        return () => {
            cancelled = true;
            window.removeEventListener("mboa-consent-change", onConsentChange);
        };
    }, []);

    return null;
}
